var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-spacer", attrs: { id: "payment-summary" } },
    [
      _c("div", [
        _c(
          "table",
          {
            staticClass: "drop-shadow-with-top",
            attrs: { id: "payment-summary-header" },
          },
          [
            _c("tr", [
              _c("td", [
                _c("div", {
                  class: {
                    "paid-animation": _vm.readyToAnimate,
                    sprite: true,
                    paid: true,
                  },
                  attrs: { id: "paid" },
                }),
                _c("div", {
                  staticClass: "sprite folded-corner",
                  attrs: { id: "corner-img" },
                }),
              ]),
              _c("td", { attrs: { id: "title", rowspan: "2" } }, [
                _vm._v(" " + _vm._s(_vm.title) + " "),
              ]),
            ]),
            _vm._m(0),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "drop-shadow-sides", attrs: { id: "rest-of-body" } },
        [
          _c("TotalDetail", { attrs: { isTipVisible: true } }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(_vm.approvedPayments.length === 0),
                  expression: "!(approvedPayments.length === 0)",
                },
              ],
              staticClass: "drop-shadow-sides",
              attrs: { id: "payment-method" },
            },
            [
              _c(
                "table",
                _vm._l(_vm.approvedPayments, function (payment) {
                  return _c("tr", { key: payment.paymentId }, [
                    _c(
                      "td",
                      { staticClass: "label-column account-type large-bold" },
                      [
                        _c("div", [_vm._v(_vm._s(payment.paymentName))]),
                        _vm.hasCardNumber(payment.paymentCard)
                          ? _c("div", { staticClass: "account-details" }, [
                              _vm._v(
                                " Card ending in " +
                                  _vm._s(payment.paymentCard.cardNumber) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "td",
                      { staticClass: "value-column charged-amount large-bold" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("toCurrency")(payment.amount + payment.tip)
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ])
                }),
                0
              ),
            ]
          ),
          !_vm.isComplete
            ? _c(
                "div",
                {
                  staticClass: "drop-shadow-sides",
                  attrs: { id: "payment-receipt-option-header" },
                },
                [_vm._v(" How would you like your receipt? ")]
              )
            : _vm._e(),
          _c(
            "keep-alive",
            [
              _vm.showEmailReceipt
                ? _c("EmailReceipt", {
                    attrs: {
                      siteId: _vm.session.siteId,
                      accountId: _vm.session.accountId,
                      checkId: _vm.session.checkId,
                      paymentId: _vm.session.payment.paymentId,
                    },
                    on: {
                      cancel: _vm.closeEmailReceipt,
                      sentEmailReceipt: _vm.sentEmailReceipt,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          !_vm.isComplete
            ? _c(
                "div",
                {
                  staticClass: "large-bold",
                  attrs: { id: "payment-receipt-option" },
                },
                [
                  !_vm.showEmailReceipt
                    ? _c(
                        "button",
                        {
                          staticClass: "button-secondary",
                          class: {
                            "button-secondary-selected":
                              _vm.selectedPaymentReceiptOption === "email",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectPaymentReceiptOption("email")
                            },
                          },
                        },
                        [_vm._v(" Email receipt ")]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "button-secondary",
                      class: {
                        "button-secondary-selected":
                          _vm.selectedPaymentReceiptOption === "print",
                      },
                      attrs: { disabled: _vm.showEmailReceipt },
                      on: {
                        click: function ($event) {
                          return _vm.selectPaymentReceiptOption("print")
                        },
                      },
                    },
                    [_vm._v(" Print receipt ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "button-secondary",
                      class: {
                        "button-secondary-selected":
                          _vm.selectedPaymentReceiptOption === "noreceipt",
                      },
                      attrs: { disabled: _vm.showEmailReceipt },
                      on: {
                        click: function ($event) {
                          return _vm.selectPaymentReceiptOption("noreceipt")
                        },
                      },
                    },
                    [_vm._v(" No receipt ")]
                  ),
                ]
              )
            : _vm._e(),
          _vm.isComplete ? _c("ThankYouMessage") : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [_c("td", { attrs: { id: "corner-img-spacer" } })])
  },
]
render._withStripped = true

export { render, staticRenderFns }